import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Text } from 'components/core/Typography';
import { Button } from 'components/core/Button';
import { STORAGE_DEALS_SEARCH_PATH } from 'config/search';

export default function DealsLink({ className }) {
	return (
		<Button
			href={STORAGE_DEALS_SEARCH_PATH}
			className={classnames('deals', className)}
			link
		>
			<Text
				className="deals-text"
				color="white"
				weight="bold"
				last
			>
				Deals
			</Text>
		</Button>
	);
}

DealsLink.propTypes = {
	className: PropTypes.string
};
